import React, { useEffect, useState } from "react";
import PublicLayout from "../components/PublicLayout";
import api from "../lib/api";
import { Cpu, Palette, Users, Clock, MapPin } from "lucide-react";

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  useEffect(() => { api.get("/programs").then((r) => setPrograms(r.data)).catch(() => {}); }, []);

  return (
    <PublicLayout>
      <section className="bg-navy topo-bg">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
          <span className="eyebrow text-exploration">H.E.A. Labs</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-white lg:text-5xl">Enrichment Programs</h1>
          <p className="mt-4 max-w-xl text-white/70">Ongoing hands-on programs where students go deep — from digital media to design.</p>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-5 py-16 lg:px-8">
        <div className="grid gap-8 md:grid-cols-2">
          {programs.map((p) => (
            <div key={p.id} data-testid={`program-${p.id}`} className="rounded-2xl border border-slate-200 bg-white p-8 card-lift">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brandblue/10 text-brandblue">
                {p.name.includes("Media") ? <Cpu className="h-6 w-6" /> : <Palette className="h-6 w-6" />}
              </div>
              <h3 className="mt-5 font-display text-2xl font-bold text-navy">{p.name}</h3>
              <p className="mt-1 text-sm font-semibold text-brandblue">{p.subject}</p>
              <p className="mt-3 text-slateBrand">{p.description}</p>
              <div className="mt-5 space-y-2 text-sm text-slateBrand">
                <div className="flex items-center gap-2"><Users className="h-4 w-4" />{p.age_grade} • Cap {p.capacity}</div>
                <div className="flex items-center gap-2"><Clock className="h-4 w-4" />{p.schedule}</div>
                <div className="flex items-center gap-2"><MapPin className="h-4 w-4" />{p.location}</div>
              </div>
              <div className="mt-5 border-t border-slate-100 pt-4 text-sm text-slateBrand">Member <span className="font-semibold text-navy">${p.member_price}</span> · <span className="font-semibold text-navy">${p.price}</span></div>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
